import type { SelectableCountry } from '@/types';

import React from 'react';
import { Form, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Box, Button, MobileInput, Stack } from '@/components';
import { useInputAttributes, useTranslation } from '@/hooks';
import { englishOnlyParams, mobileRegex, yupValidator } from '@/utils';

type ReferralMobileFormData = {
  mobile: string;
};

type ReferralMobileFormProps = {
  onNext: (data: ReferralMobileFormData) => void;
  getInquiriesLoading: boolean;
};

const ReferralMobileForm: React.FC<ReferralMobileFormProps> = ({
  onNext,
  getInquiriesLoading,
}) => {
  const { t } = useTranslation('pages.signUp.form.referralForm.mobileForm');

  const [selectedCountry, setSelectedCountry] =
    React.useState<SelectableCountry>('iran');

  const validationSchema = yupValidator.object().shape({
    mobile: yupValidator
      .string()
      .test({ ...englishOnlyParams })
      .matches(mobileRegex[selectedCountry], t('invalidNumber'))
      .label(t('mobile'))
      .required(),
  });

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const filedInputProps = useInputAttributes<ReferralMobileFormData>(
    control,
    register,
    errors,
    {
      mobile: '',
    }
  );

  const onSubmit = (data: ReferralMobileFormData) => {
    onNext(data);
  };

  return (
    <Box display="flex" flexDirection="column" w="100%" h="100%" flexGrow={1}>
      <Form
        control={control}
        style={{
          width: '100%',
          flexGrow: 1,
          gap: 16,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <Box display="flex" flexDirection="column" height="100%" flexGrow={1}>
          <Box flexGrow={1}>
            <MobileInput
              inputProps={{ ...filedInputProps.mobile }}
              selectedCountry={selectedCountry}
              setSelectedCountry={setSelectedCountry}
            />
          </Box>
          <Stack w="100%" align="flex-end" mt={4}>
            <Button
              w="full"
              type="submit"
              onClick={(data) => void handleSubmit(onSubmit)(data)}
              isLoading={getInquiriesLoading}
            >
              {t('check')}
            </Button>
          </Stack>
        </Box>
      </Form>
    </Box>
  );
};
export default ReferralMobileForm;
